export default {
  key: 'C',
  suffix: 'major',
  positions: [
    {
      frets: 'x32010',
      fingers: '032010'
    },
    {
      frets: 'x35553',
      fingers: '012341',
      barres: 3,
      capo: true
    },
    {
      frets: 'xx5558',
      fingers: '001114',
      barres: 5
    },
    {
      frets: '8aa988',
      fingers: '134211',
      barres: 8,
      capo: true
    }
  ]
};
